<template>
  <div>
    <v-expansion-panel expand :value="[true]">
      <v-expansion-panel-content>
        <div slot="header">
          <v-icon>mdi-filter-variant</v-icon> Filters
        </div>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xl3 lg4 xs6>
                  <v-autocomplete :items="benefitList" v-model="filters.benefit" :label="filtersLabel.benefit" item-text="label" item-value="value" data-vv-name="benefit" :data-vv-as="filtersLabel.benefit" :error-messages="errors.collect('benefit')" clearable></v-autocomplete>
                </v-flex>
                <v-flex xl3 lg4 xs6>
                  <cal-picker :label="filtersLabel.effDate" v-model="filters.effDate" :error-messages="errors.collect('filters.effDate')" data-vv-name="effDate" :data-vv-as="filtersLabel.effDate"></cal-picker>
                </v-flex>
                <v-flex xl3 lg4 xs6>
                  <v-autocomplete :items="benefitTypeList" v-model="filters.benType" :label="filtersLabel.benType" item-text="label" item-value="value" :error-messages="errors.collect('filters.benType')" data-vv-name="benType" :data-vv-as="filtersLabel.benType" clearable></v-autocomplete>
                </v-flex>
              </v-layout>
              <transition name="slide-x-transition" mode="out-in">
                <v-layout row wrap v-if="showDetailFilters">
                  <v-flex xl3 lg4 xs6>
                    <v-text-field v-model="filters.napSubLevel" :label="filtersLabel.napSubLevel" :error-messages="errors.collect('filters.napSubLevel')" data-vv-name="napSubLevel" :data-vv-as="filtersLabel.napSubLevel" v-validate="'numeric|max:10'"></v-text-field>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-autocomplete :items="gapCalcMethodList()" v-model="filters.gapCalcMethod" :label="filtersLabel.gapCalcMethod" item-text="label" item-value="value" :error-messages="errors.collect('filters.gapCalcMethod')" data-vv-name="gapCalcMethod" :data-vv-as="filtersLabel.gapCalcMethod" clearable></v-autocomplete>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-autocomplete :items="booleanList" v-model="filters.addBen" :label="filtersLabel.addBen" item-text="label" item-value="value" :error-messages="errors.collect('filters.addBen')" data-vv-name="addBen" :data-vv-as="filtersLabel.addBen" clearable></v-autocomplete>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-autocomplete :items="booleanList" v-model="filters.defBen" :label="filtersLabel.defBen" item-text="label" item-value="value" :error-messages="errors.collect('filters.defBen')" data-vv-name="defBen" :data-vv-as="filtersLabel.defBen" clearable></v-autocomplete>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-autocomplete :items="booleanList" v-model="filters.protSi" :label="filtersLabel.protSi" item-text="label" item-value="value" :error-messages="errors.collect('filters.protSi')" data-vv-name="protSi" :data-vv-as="filtersLabel.protSi" clearable></v-autocomplete>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-text-field v-model="filters.minSi" v-num-mask="{negative: true, intScale: 18}" :label="filtersLabel.minSi" :error-messages="errors.collect('minSi')" data-vv-name="minSi" :data-vv-as="filtersLabel.minSi"></v-text-field>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-text-field v-model="filters.maxSi" v-num-mask="{negative: true, intScale: 18}" :label="filtersLabel.maxSi" :error-messages="errors.collect('maxSi')" data-vv-name="maxSi" :data-vv-as="filtersLabel.maxSi"></v-text-field>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-text-field v-model="filters.basedUom" :label="filtersLabel.basedUom" :error-messages="errors.collect('basedUom')" data-vv-name="basedUom" :data-vv-as="filtersLabel.basedUom" v-validate="'numeric|max:10'"></v-text-field>
                  </v-flex>
                </v-layout>
              </transition>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
            <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
          </v-card-actions>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-flex xs12>
      <v-layout row>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-spacer></v-spacer>
        <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
          <v-btn color="secondary" class="white--text" slot="activator">
            <span>Columns</span>
            <v-icon right dark>mdi-table-column-plus-after</v-icon>
          </v-btn>
          <v-card>
            <v-card-text>
              <template v-if="columns.length > 0">
                <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
              </template>
              <template v-else>
                No column found
              </template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-layout>
    </v-flex>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td v-for="column in selectedColumns" :key="column">
          {{props.item[column]}}
        </td>
        <td class="text-xs-right">
          <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doCreate">New Benefit<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Tariff Benefit?
      <div class="title">{{deleteTarfBen}}</div>
    </confirm>
  </div>
</template>

<script>
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/parameters/reusable/listMixins'
import { filterQuery, expandURI } from '@/utils/ajax'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number.js'
import { mtrGapCalcMethod } from '@/const/underwriting/motor'
export default {
  data() {
    return {
      benefitList: [],
      benefitTypeList: [],
      filtersLabel: {
        benefit: 'Benefit',
        gapCalcMethod: 'Gap Calculation Method',
        benType: 'Benefit Type',
        napSubLevel: 'Nap Sub Level',
        addBen: 'Add Benefit',
        defBen: 'Default Benefit',
        minSi: 'Min Sum Insured',
        maxSi: 'Max Sum Insured',
        protSi: 'Protect Sum Insured',
        basedUom: 'Based Unit Of Measure',
        effDate: 'Effective Date',
        expDate: 'Expired Date'
      },
      filters: {
        benefit: null,
        gapCalcMethod: null,
        benType: null,
        napSubLevel: null,
        addBen: null,
        defBen: null,
        minSi: null,
        maxSi: null,
        protSi: null,
        basedUom: null,
        effDate: null
      },
      columns: [
        { text: 'Benefit', value: 'benefitDesc' },
        { text: 'Gap Calculation Method', value: 'gapCalcMethodDesc' },
        { text: 'Benefit Type', value: 'benTypeDesc' },
        { text: 'Nap Sub Level', value: 'napSubLevel' },
        { text: 'Add Benefit', value: 'addBen' },
        { text: 'Default Benefit', value: 'defBen' },
        { text: 'Min Sum Insured', value: 'minSi' },
        { text: 'Max Sum Insured', value: 'maxSi' },
        { text: 'Protect Sum Insured', value: 'protSi' },
        { text: 'Based Uom', value: 'basedUom' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expired Date', value: 'expDate' }
      ],
      selectedColumns: ['benefitDesc', 'benTypeDesc', 'effDate', 'expDate'],
      pagination: {
        sortBy: 'seqNo'
      },
      booleanList: [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ],
      showDetailFilters: false,
      deleteTarfBen: '',
      promptRemove: false
    }
  },
  watch: {
    'fetchBenefit': function(value) {
      if (value !== false) {
        this.fetchData(false)
      }
    },
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    },
    'ids.tarf': function (value) {
      this.$emit('resetTab', 1)
    }
  },
  computed: {
    busClsTariffMenu() {
      return this.$store.state.parameters.busCls.tariff.menu
    }
  },
  methods: {
    minValidation(value) {
      const min = removeFormatNumber(value)
      return 'mask_min_value:' + min
    },
    maxValidation(value) {
      const max = removeFormatNumber(value)
      return 'mask_max_value:' + max
    },
    async fetchData(options) {
      const apiURI = this.busClsTariffMenu.tarfBens
      const { page, rowsPerPage } = this.pagination
      let expand = {
        busCls: this.ids.busCls,
        tarf: this.ids.tarf,
        effDate: this.filters.effDate,
        page: page - 1,
        size: rowsPerPage
      }
      if (apiURI) {
        try {
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          const { data } = result.data
          this.benefitList = result.data.benefitList
          this.benefitTypeList = result.data.benefitType
          if (data) {
            this.items = []
            data.map((tarfBen) => {
              const convertList = {
                benefitDesc: tarfBen.benefit + ' - ' + tarfBen.benefitDesc,
                benefit: tarfBen.benefit,
                gapCalcMethod: tarfBen.gapCalcMethod,
                gapCalcMethodDesc: tarfBen.gapCalcMethod + ' - ' + mtrGapCalcMethod[tarfBen.gapCalcMethod],
                benType: tarfBen.benType,
                benTypeDesc: tarfBen.benType + ' - ' + tarfBen.benTypeDesc,
                napSubLevel: tarfBen.napSubLevel,
                addBen: this.formatBoolean(tarfBen.addBen),
                defBen: this.formatBoolean(tarfBen.defBen),
                minSi: formatDisplayNumber(tarfBen.minSi),
                maxSi: formatDisplayNumber(tarfBen.maxSi),
                protSi: this.formatBoolean(tarfBen.protSi),
                basedUom: tarfBen.basedUom,
                expDate: this.formatDate(tarfBen.expDate),
                effDate: this.formatDate(tarfBen.effDate)
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
            this.loading = false
          }
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Tariff Benefit List')
      }
    },
    doClearFilters() {
      this.filters.benefit = null
      this.filters.gapCalcMethod = null
      this.filters.benType = null
      this.filters.napSubLevel = null
      this.filters.addBen = null
      this.filters.defBen = null
      this.filters.minSi = null
      this.filters.maxSi = null
      this.filters.protSi = null
      this.filters.basedUom = null
      this.filters.effDate = null
      this.fetchData(true)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
          this.resetValidator()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doReview(data) {
      const ben = data.item
      this.$emit('doReview', ben)
    },
    doCreate() {
      this.$emit('doCreate')
    },
    gapCalcMethodList() {
      const list = Object.freeze(mtrGapCalcMethod)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedTarfBen = data
        this.deleteTarfBen = data.benefitDesc
      }
    },
    async doRemove() {
      const apiURI = this.busClsTariffMenu.tarfBenDelete
      if (apiURI) {
        this.loading = true
        if (this.selectedTarfBen.minSi === undefined) {
          this.selectedTarfBen.minSi = null
        }
        if (this.selectedTarfBen.maxSi === undefined) {
          this.selectedTarfBen.maxSi = null
        }
        const formatForm = {
          tarf: this.ids.tarf,
          busCls: this.ids.busCls,
          benefit: this.selectedTarfBen.benefit,
          gapCalcMethod: this.selectedTarfBen.gapCalcMethod,
          benType: this.selectedTarfBen.benType,
          napSubLevel: this.selectedTarfBen.napSubLevel,
          addBen: this.removeFormatBoolean(this.selectedTarfBen.addBen),
          defBen: this.removeFormatBoolean(this.selectedTarfBen.defBen),
          minSi: formatDisplayNumber(this.selectedTarfBen.minSi),
          maxSi: formatDisplayNumber(this.selectedTarfBen.maxSi),
          protSi: this.removeFormatBoolean(this.selectedTarfBen.protSi),
          basedUom: this.selectedTarfBen.basedUom,
          expDate: this.removeFormatDate(this.selectedTarfBen.expDate),
          effDate: this.removeFormatDate(this.selectedTarfBen.effDate)
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(true)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Tariff Benefit')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    },
    removeFormatBoolean(boolean) {
      if (boolean === 'Yes') {
        return true
      } else {
        return false
      }
    }
  },
  props: {
    ids: Object,
    fetchBenefit: Boolean
  },
  mixins: [
    listMixin,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
